import { Injectable } from '@angular/core';
import { LMUrlUtilService } from '../services/utils/lm-url-util.service';
import {
  LMContextService,
  LMLoggerService,
  LMPersonalizationPersistenceService,
  LMRouteComponentService,
  LMSpecService,
  LMUrlInfoBuilderService
} from '../services';
import { NavigationExtras, Router } from '@angular/router';
import { DocumentResource } from '../resources';
import { BehaviorSubject, combineLatest, Observable, of, Subscriber, Subscription, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import * as urltemplate from 'url-template';
import { AppConstants, LMDialogButtonKey } from './app.constants';
import { SohoMessageService, SohoToastService } from 'ids-enterprise-ng';
import { LMBannerNavComponent } from '../components/banner';
import * as _ from 'lodash';
import { LMGlobalPersonalization, LMGlobalPersonalizationService } from '@app/states';
import { LMManualRepresentationComponent, LMUrlDocSaveResult } from '@app/components';

@Injectable()
export class LMGlobalUtilService {

  constructor(
    private router: Router,
    private http: HttpClient,
    private lmContextService: LMContextService,
    private lmLoggerService: LMLoggerService,
    private lmSpecService: LMSpecService,
    private lmUrlUtilService: LMUrlUtilService,
    private lmRouteComponentService: LMRouteComponentService,
    private sohoToastService: SohoToastService,
    private lmUrlInfoBuilderService: LMUrlInfoBuilderService,
    private lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    private lmSessionStorageService: LMPersonalizationPersistenceService,
    private sohoMessageService: SohoMessageService,
  ) {}

  public getNavContextKeys(params: any) {
    const navContextKeys: any = {};
    for (const key in params) {
      if (typeof key === 'string'
        && key.indexOf('nc.') === 0) {
        navContextKeys[ key ] = params[ key ];
      }
    }
    return navContextKeys;
  }

  public navigate(url: string, params: any = null, option: any = null) {
    let openInNewTab: any;

    // todo/sjw xi: can remove this?
    // if (window.isSpa)
    // {
    //    if (url.indexOf("fragment=") < 0)
    //        url = this.insertFragmentParam(url);
    //
    //    this.loadContent(url, "Need to get", true)
    //    return;
    // }

    if (params) {
      url = this.lmUrlUtilService.appendToQueryString(url, this.lmUrlUtilService.objectToQueryString(params));
    }

    if (option === 'replace') {
      window.location.replace(url);
    } else {
      openInNewTab = option === 'external' || false;

      try {
        if (openInNewTab) {
          this.lmUrlUtilService.openExternalUrl(url);
        } else {
          window.location.href = url;
        }
      } catch (e) {

        // Catch errors in IE for the onbeforeunload event;
        // Jquery fails in IE when discarding the second event of a jQuery.event.trigger() and
        // when an event is called after a page has unloaded.

        // IE throws a JS error if "Stay on this page" is chosen in the confirmation dialog.
        // if (this.browserUtil.isIE && e.message.length === 0 && e.description.length === 0)
        //     return;
        //
        // this.dialogUtil.showErrorDialog("Error Opening URL", e);
      }
    }
  }

  public compare(obj1: Object, obj2: Object): boolean {

    // Create arrays of property names
    const props1 = Object.getOwnPropertyNames(obj1);
    const props2 = Object.getOwnPropertyNames(obj2);

    // If number of properties is different objects are not equivalent
    if (props1.length !== props2.length) {
      return false;
    }

    for (let i = 0; i < props1.length; i++) {
      const propName = props1[i];

      // If values of same property are not equal, objects are not equivalent
      if (obj1[propName] !== obj2[propName]) {
        return false;
      }
    }

    // If we made it this far, objectvare considered equivalent
    return true;
  }

  private getHashCompareUrl(urlIn: string): string {
    if (this.lmUrlUtilService.isAbsoluteUrl(urlIn)) {
      // first check to see if it has the protocol and remove it
      urlIn = this.lmUrlUtilService.toRelativeUrl(urlIn);
    }
    return urlIn.split('#')[0];
    // const protocolStriped = (urlIn.startsWith('http://') || urlIn.startsWith('https://')) ? urlIn.substring((urlIn.indexOf('//') + 2)) : urlIn;
    // const pathUrl: string = protocolStriped.indexOf('#') >= 0 ? protocolStriped.split('#')[0] : protocolStriped;
    // return pathUrl;
  }

  /**
   * prepares the url and routes to it
   * @param url The url to route to.
   * todo placed here because of circular dependency issues.
   */
  public navigateByUrl(url: string, extras?: NavigationExtras): Promise<boolean> {

    // if the path is the same and the url has a # then instead of allowing the nevigation to the url we fire an HashChangeEvent.
    const urlAndHash = url.split('#');
    if (urlAndHash.length === 2 // hash exist on url
    &&  this.lmUrlUtilService.isPageUrl(url)
    &&  this.lmUrlUtilService.isPageUrl(this.router.url)
    &&  this.pageCurrentAndNavigationUrlsMatch(this.router.url, url)) {
      const comp = this.lmRouteComponentService.getRouteComponent();
      if (comp['hashTagChanged']) {
        if (comp['hashTagChanged'](urlAndHash[0], urlAndHash[1])) {
          return;
        }
      }
    }

    if (url.indexOf('/menu/') >= 0) {
      this.lmSpecService.getBannerSpec(url).subscribe(
        response => {
          if (response.redirectUrl) {
            if (response.external) {
              this.lmUrlUtilService.openExternalUrl(response.redirectUrl);
            } else if (response.embedded) {

              if (url.length > 0) {
                const isHtmlFragment = response.redirectUrl.indexOf('standalone=true') < 0;
                const webapp = this.lmContextService.getContext().webApp;
                const dataArea = this.lmContextService.getContext().urlPdlOrDa;
                let autoLoadUrl = dataArea + '/' + webapp + '/html/url?autoLoadUrl=' + encodeURIComponent(response.redirectUrl);
                autoLoadUrl = this.lmUrlUtilService.updateContextSessionKeyParams(autoLoadUrl);
                this.navigateByUrl(autoLoadUrl);
              }
            } else {
              const redirectUrl = this.lmUrlUtilService.updateContextSessionKeyParams(response.redirectUrl);
              const noDefaultPortUrl = this.lmUrlUtilService.stripDefaultPort(redirectUrl);
              this.navigateByUrl(noDefaultPortUrl).then((completed?: boolean) => {
                this.lmLoggerService.log('navigationByUrl completed?: ' + completed);
              });
            }
          }
        },
        error => {
          this.lmLoggerService.log('Unable to find menu');
        });
      return;
    }

    let relativeUrl = this.lmUrlUtilService.toRelativeUrl(url);
    relativeUrl = this.lmUrlUtilService.encodePlus(relativeUrl);
    relativeUrl = this.lmUrlUtilService.encodeParens(relativeUrl);

    // ---------------------------------------------------------------------------
    // todo ppatton if navigating to a new route (form) then apply paging
    // information to the url so the form next/prev functionality works.
    // ---------------------------------------------------------------------------
    return this.router.navigateByUrl(relativeUrl, extras);
  }

  public syncWebappMenu(url: string, bannerNavComponent: LMBannerNavComponent) {
    const urlWebAppName = this.lmUrlUtilService.getWebAppNameFromUrl(url);
    if (urlWebAppName !== this.lmContextService.getWebApp()) {
      this.lmLoggerService.log(
        `webApp change detected: new webApp: ${urlWebAppName}, old webapp: ${this.lmContextService.getWebApp()}`);

      // now switch the menu to the future webapp menu if it is different than the current urls
      const webApps: LMWebAppSpec[] = this.lmContextService.getAccessibleWebApps();
      const urlWebAppSpec = webApps ? webApps.filter(webAppSpec => webAppSpec.webAppName === urlWebAppName) : [];
      if (urlWebAppSpec && urlWebAppSpec.length === 1) {
        this.updateWebappMenu(urlWebAppName, bannerNavComponent);
      }
    }
  }

  public updateWebappMenu(webAppName: string, bannerNavComponent: LMBannerNavComponent) {
    const accessableWebApps = this.lmContextService.getAccessibleWebApps();
    const urlWebAppSpec: LMWebAppSpec[] = accessableWebApps ? accessableWebApps.filter(webAppSpec => webAppSpec.webAppName === webAppName) : [];
    if (urlWebAppSpec.length === 1) {
      this.lmContextService.updateWebApp(urlWebAppSpec[0]);
      if (bannerNavComponent) {
        bannerNavComponent.getBannerPersonalization();
        bannerNavComponent._loadMenu(this.lmUrlUtilService.getBannerSpecUrl(), true);
      }
    }
  }

  public updateClientStatsTelegraf(info: LMComponentInfo, loadTime: number): Observable<any> {
    if (!this.lmContextService.isMonocleEnabled()) {
      return of();
    }

    const telegrafProperties: LMTelegrafProperties = this.getUrlRequestInfoJson(info, loadTime, true);
    return this.sendClientStatsTelegraf(telegrafProperties, false);
  }

  // use this to send information to Telegraf
  public sendClientStatsTelegraf(telegrafProperties: LMTelegrafProperties, custom: boolean, name?: string): Observable<any>  {

    this.lmLoggerService.log([ this, this.lmLoggerService.instanceId, 'updateClientStatsTelegraf' ]);
    telegrafProperties['custom'] = custom;
    telegrafProperties['customName'] = name;

    const postContent: any = {
      requestType:    'telegraf',
      telegrafProperties
    };

    return this.http.post(this.lmUrlUtilService.getTelegrafUrl(), postContent).pipe(
      catchError(error => throwError(error || 'Server error')));
  }

  public getUrlRequestInfoJson(info: LMComponentInfo, loadTime: number, configFlags?: boolean): TelegrafProperties {
    const context: LMContext = this.lmContextService.getContext();
    const sharePageAnalyticParts: string[] = context ? context.sharePageAnalytics.split('_') : [];
    const accountId: string = sharePageAnalyticParts.length > 0 ? sharePageAnalyticParts[ 0 ] : '';
    const application: string = sharePageAnalyticParts.length > 1 ? sharePageAnalyticParts[ 1 ] : 'Improper_sharePageAnalytic';
    const environmentType: string = sharePageAnalyticParts.length > 2 ? sharePageAnalyticParts[ 2 ] : 'Improper_sharePageAnalytic';
    // let telegrafUrl = this.lmUrlUtilService.getTelegrafUrl();
    const urlSplit = this.router.url.split('?');

    const  telegrafProperties: TelegrafProperties = {
      accountId,
      actorUniqueId: context ? context.actorUniqueId : '',
      webApp: context ? context.webApp : '',
      userWebRequestId: info ? info.userWebRequestId : '',
      application,
      environmentType,
      isoLocale: Soho.Locale.currentLocale.name,
      //  url: urlSplit[0],   Removed per Andrew 8/11/2021
      urlParams: urlSplit.length > 1 ? this.filterAllowableParams(this.router.url) : '',   // this.activatedRoute.params,
      userAgent: navigator.userAgent,
      businessClass: info ? info.busClassName : '',
      uiView: info ? info.name : '',
      uiViewType: info ? info.componentType : this.getUIType(urlSplit[0]),
      displayType: info ? info.displayType : '',
      tenant: info ? info.tenant : '',
      envType: info ? info.envType : '',
      module: info ? info.module : '',
      message: info ? info.message : '',
    };

    if (configFlags) {
      telegrafProperties['loadTime'] = loadTime ? loadTime : -1;
      telegrafProperties['developer'] = info ? info.developer : false;
      telegrafProperties['isConfigured'] = info && info.configInfo ? info.configInfo.configuration : false;
      telegrafProperties['isPersonalized'] = info && info.configInfo ? info.configInfo.personalization : false;
      telegrafProperties['userFolder'] = info && info.configInfo ? info.configInfo.userlist : false;
    }

    return telegrafProperties;
  }

  private filterAllowableParams(url: string): string {
    const approvedArray: Array<string> = [ 'action', 'csk.showusingxi', 'csk.ng', 'csk.mi', 'csk.CHP', 'csk.hidemenubar', 'csk.hidetitlebar', 'csk.developer',
      'csk.dbsessiondebug', 'csk.gen', 'csk.3x', 'csk.mw' ];

    let filteredParams = '';
    const urlParams = this.lmUrlUtilService. getUrlParams(url);
    const paramArray = Object.keys(urlParams);
    const overlap = _.intersectionWith(approvedArray, paramArray, _.isEqual);
    overlap.map(key => {
      filteredParams += '&' + key + '=' + urlParams[key];
    });

    return filteredParams;
  }

  private getUIType(url: string): string {
    if (url.indexOf('/home/') > -1) {
      return 'HOME';
    } else if (url.indexOf('/page/') > -1) {
      return 'PAGE';
    }

    return '';
  }

  private pageCurrentAndNavigationUrlsMatch(currentUrl: string, navigationUrl: string): boolean {
    const fromUrl: string = this.getHashCompareUrl(currentUrl.toLowerCase());
    const toUrl: string = this.getHashCompareUrl(navigationUrl);
    const fromUrlInfo = this.lmUrlInfoBuilderService.getPageUrlInfoFromHttpUrl(fromUrl);
    const toUrlInfo = this.lmUrlInfoBuilderService.getPageUrlInfoFromHttpUrl(toUrl);

    // ---------------------------------------------------------------------------
    // if the resourceIds do not match then urls do not match
    // ---------------------------------------------------------------------------
    if (fromUrlInfo.resource.resourceId !== toUrlInfo.resource.resourceId) {
      return false;
    }

    // ---------------------------------------------------------------------------
    // if no sourceResourceIds then the urls match
    // ---------------------------------------------------------------------------
    if (!fromUrlInfo.sourceResource && !toUrlInfo.sourceResource) {
      return true;
    }

    // ---------------------------------------------------------------------------
    // if there are sourceResources then if they are navigation or drill the
    // resourceId must match
    // ---------------------------------------------------------------------------
    if (fromUrlInfo.sourceResource && toUrlInfo.sourceResource) {
      if (fromUrlInfo.sourceResource.resourceType === AppConstants.RESOURCETYPE_NAVIGATION
      &&  toUrlInfo.sourceResource.resourceType === AppConstants.RESOURCETYPE_NAVIGATION) {
        return fromUrlInfo.sourceResource.resourceId === toUrlInfo.sourceResource.resourceId;
      }

      if (fromUrlInfo.sourceResource.resourceType === AppConstants.RESOURCETYPE_DRILL
      &&  toUrlInfo.sourceResource.resourceType === AppConstants.RESOURCETYPE_DRILL) {
        return fromUrlInfo.sourceResource.resourceId === toUrlInfo.sourceResource.resourceId;
      }
    }

    // ---------------------------------------------------------------------------
    // if either or both have a sourceResourceTypes are 'menu' then it ok to
    // ignore that and consider this a match
    // ---------------------------------------------------------------------------
    if ((fromUrlInfo.sourceResource && fromUrlInfo.sourceResource.resourceType === AppConstants.RESOURCETYPE_MENU)
    ||  (toUrlInfo.sourceResource && toUrlInfo.sourceResource.resourceType === AppConstants.RESOURCETYPE_MENU)) {
      return true;
    }

    return false;
  }

  public displayToastMessage(title: string, message: string, resultAttributeValue?: string, allowLink?: boolean) {
    const toastIDAttributes: SohoAttributesArray = [];
    toastIDAttributes.push({ name: 'data-automation-id', value: 'lm-toast-message-container' });
    if (resultAttributeValue?.trim().length > 0) {
      toastIDAttributes.push({ name: 'toast-message-result', value: resultAttributeValue.trim() });
    }

    const position = this.getToastMessagePosition();
    const duration = this.getToastMessageDuration();

    const toastOptions = {
      title,
      message,
      position,
      allowLink: allowLink || false,
      draggable: true,
      savePosition: true,
      progressBar: false,
      timeout: duration, // 30000, // for debugging
      attributes: toastIDAttributes,
      uniqueid: (this.lmContextService.getActorUniqueId() === null) ? 'message' : this.lmContextService.getActorUniqueId()
    };
    // when passing in uniqueid soho will append toast- -usersettings-position to localStorage item
    this.sohoToastService.show(toastOptions);
  }

  public getToastMessagePosition(): SohoToastPosition {
    const bannerPersonalization: LMGlobalPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();
    const configParam = this.lmContextService.getToastMessagePosition();
    let position = null;

    if (bannerPersonalization.toastMessagePosition && bannerPersonalization.toastMessagePosition !== 'DEFAULT') {
      position = bannerPersonalization.toastMessagePosition;
    } else if (configParam) {
      position = configParam;
    } else {
      return SohoToastService.TOP_RIGHT;
    }

    if (position === 'TOP_LEFT') {
      return SohoToastService.TOP_LEFT;
    } else if (position === 'TOP_RIGHT') {
      return SohoToastService.TOP_RIGHT;
    } else if (position === 'BOTTOM_LEFT') {
      return SohoToastService.BOTTOM_LEFT;
    } else if (position === 'BOTTOM_RIGHT') {
      return SohoToastService.BOTTOM_RIGHT;
    } else {
      return SohoToastService.TOP_RIGHT;
    }
  }

  public getToastMessageDuration(): number {
    const bannerPersonalization: LMGlobalPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();
    const configParam = this.lmContextService.getToastMessageDuration();
    let duration = null;

    if (bannerPersonalization.toastMessageDuration) {
      duration = bannerPersonalization.toastMessageDuration;
    } else if (configParam) {
      duration = configParam;
    } else {
      return 6000;
    }

    if (duration === 'SHORTER') {
      return 4000;
    } else if (duration === 'DEFAULT') {
      return 6000;
    } else if (duration === 'LONGER') {
      return 8000;
    } else {
      return 6000;
    }
  }

  public displayAsOfDateInPastMessage() {
    const dialogId = 'RunActionAsOfDate';
    this.sohoMessageService
      .message()
      .message(Soho.Locale.translate('RunActionAsOfDate'))
      .title(Soho.Locale.translate('ActionNotAllowed'))
      .buttons([
        {
          id: dialogId + '_' + LMDialogButtonKey.CLOSE,
          text: Soho.Locale.translate(LMDialogButtonKey.CLOSE),
          click: (e, modal) => {
            modal.close(true);
          }
        },
      ])
      .open();
  }

  public runSaveManualReps(observer: Subscriber<boolean>, manualRefComps: LMManualRepresentationComponent[]) {
    // process here should be to try to save the manual reps first and if they do not save properly do not save the form.
    //  const refs: LMManualRepresentationComponent[] = this.lmHtmlUrlDocService.getManualRefCompRefs();
    const manualRepSaves = [];
    for(const comp of manualRefComps) {
      const manRepObservable: BehaviorSubject<LMUrlDocSaveResult> = comp.runSave();
      manualRepSaves.push(manRepObservable);
    }
    const combineSubscrption = combineLatest(manualRepSaves).subscribe(
      res => {
        const hasErrors = res.filter( (saved: LMUrlDocSaveResult ) => saved.isError === true);
        const complete = res.filter( (saved: LMUrlDocSaveResult ) => saved.isComplete !== true);
        if (hasErrors.length) {
          this.displayToastMessage("", (hasErrors[0] as LMUrlDocSaveResult).message, 'unknown');
          observer.next(false);
          observer.complete();
          this.cleanupManualRepSave(combineSubscrption, manualRepSaves);
        } else if (complete.length) {
          // got no errors but not all are complete so keep going
        } else {
          observer.next(true);
          observer.complete();
          this.cleanupManualRepSave(combineSubscrption, manualRepSaves);
        }
      },
    );
  }

  cleanupManualRepSave(combineSubscrption: Subscription, res: any[]) {
    combineSubscrption.unsubscribe();
    res.map( (item: BehaviorSubject<LMUrlDocSaveResult>) => {item.complete()});
  }
}
